import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";
import apiRequestType from "../../apiRequestType";

const getUserGroupMembers = (userGroupId, allHierarchicalMembers) => {
  return apiRequestType(
    apiTypes.GET,
    apiConstants.ADMIN.GROUP_MANAGEMENT.GET_USER_GROUP_MEMBERS(
      userGroupId,
      allHierarchicalMembers
    )
  );
};

export default getUserGroupMembers;
